import React from "react";
import {
  Box,
  Chip,
  Col,
  Flex,
  Row,
  Typography,

} from "../../../../ppui";
import { AllowanceBox } from "../../../style";
import { TbAlertTriangle } from "react-icons/tb";

const AllowanceList = ({ isFetching, allowanceListResponse}) => {
  if (isFetching) {
    throw new Promise(() => { });
  }
  return (
    <Flex gap={20} direction={"column"}>
      {allowanceListResponse?.allowances?.length > 0 ?
        allowanceListResponse?.allowances?.map((it) => (
          <AllowanceBox key={it?.allowanceName}>
            <Row alignItems="center">
              <Col>
                <Row alignItems="center" gap={{ md: 20, lg: 30, xxl: 60 }}>
                  <Col md={4} xl={3}>
                    <Box className="value">{it?.allowanceName} allowance</Box>
                    <Box className="value">
                      {it?.allowanceType === "percentage" ?
                        (<>
                          {it?.allowanceValue}%  of basic
                        </>) :
                        (<>
                          ₹{it?.allowanceValue} {it?.allowanceType} Amount 
                        </>)
                      }
                    </Box>
                  </Col>

                  {/* <Col>
                    <Box className="label"> Type</Box>
                    <Box className="value">{it?.allowanceType}</Box>
                  </Col>
                  <Col>
                    <Box className="label"> Amount</Box>
                    <Box className="value">{it?.allowanceValue}</Box>
                  </Col> */}
                  <Col md={5} xl={3}>
                    <Box className="label">{(!it?.isEpfWages && !it?.isEsiWages) && "Not "} Included in </Box>
                    <Box className="value">{it?.isEpfWages && "EPF"}{(it?.isEpfWages && it?.isEsiWages) && " & "}{it?.isEsiWages && "ESI"} {(!it?.isEpfWages && !it?.isEsiWages) && "EPF & ESI"} wages</Box>
                  </Col>
                  <Col>
                    <Box className="label"> Pay For</Box>
                    <Box className="value">{it?.noWorkNoPay ? "Present Days" : "Payable Days"}</Box>
                  </Col>
                  
                  
                  <Col>
                    <Box className="label"> Status</Box>
                    <Box className="value"><Chip
                        color={it?.status ? "success" : "danger"}
                        label={it?.status ? "Active" : "Inactive"}
                        onClick={() => { }}
                        size='sm'
                        dot
                      /> </Box>
                  </Col>
                </Row>
              </Col>
            </Row>
          </AllowanceBox>
        ))
        :
        <AllowanceBox >
          <Typography variant="body1" display="flex" gap={10} alignItem="center" mb={"0"} p={15}>
            <TbAlertTriangle />
            No predefined allowances available
          </Typography>
        </AllowanceBox>


      }


    </Flex>
  )
}

export default AllowanceList